export const DEFAULT_DOCUMENT_LIMIT = 10
export const CHAT_VERSION_DOCUMENT_LIMIT = 10
